<template>
  <nav class="index-breadcrumbs" aria-label="Breadcrumb">
    <ol class="index-breadcrumbs__list">
      <li class="index-breadcrumbs__item">
        <NuxtLink :to="homeUrl" class="index-breadcrumbs__link">
          <span class="index-breadcrumbs__home-icon" aria-hidden="true">
            <img
              class="index-breadcrumbs__home-icon-img"
              src="/assets/images/about/home-icon.svg"
              width="16"
              height="16"
              alt=""
              aria-hidden="true"
              loading="eager"
              decoding="async"
            />
          </span>
          <span class="index-breadcrumbs__home-text">{{ homeLabel }}</span>
        </NuxtLink>
      </li>

      <li class="index-breadcrumbs__separator" aria-hidden="true">›</li>

      <li class="index-breadcrumbs__current" aria-current="page">
        {{ currentLabel }}
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useIndexRoutes } from '@/composables/locale/useIndexRoutes'

interface Props {
  currentLabel: string
  homeLabel?: string
}

const props = defineProps<Props>()

const { t } = useI18n()
const { buildPath } = useIndexRoutes()

const homeUrl = computed(() => buildPath())
const homeLabel = computed(() => props.homeLabel ?? t('seo.breadcrumbs.home'))
</script>

<style scoped>
.index-breadcrumbs {
  color: rgba(255, 255, 255, 0.95);
  font-family: var(--font-inter);
  font-size: 16px;
  line-height: 1.4;
  font-weight: 500;
}

.index-breadcrumbs__list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
  margin: 0;
}
@media (max-width: 768px) {
  .index-breadcrumbs__list {
    justify-content: center;
  }
}
.index-breadcrumbs__link {
  color: inherit;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.index-breadcrumbs__home-icon-img {
  width: 16px;
  height: 16px;
  display: block;
}

.index-breadcrumbs__link:hover {
  text-decoration: underline;
}

.index-breadcrumbs__separator {
  opacity: 0.9;
}

.index-breadcrumbs__current {
  opacity: 0.98;
}
</style>

